import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { calendar } from '@primeicons/core/calendar';

@Component({
    selector: 'svg[data-p-icon="calendar"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class Calendar extends CoreIcon {
    constructor() {
        super();
        this._icon = calendar;
    }
}
